var cov_4ci5pu20k = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/index.js",
      hash = "819f6324092fb935b45c24638e410df6483e7458",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

// Created by scripts/src-index.js.
import * as utils from './utils';
export default {
  utils: utils,
  version: '2.0.10'
};
export { utils };
export { setLocale } from './locale';
export { color, style } from './utils/expose';
export { default as config, setConfig, isRTL } from './config';
export { default as LazyList } from './AnimationList/LazyList';
export { default as Alert } from './Alert';
export { default as AnimationList } from './AnimationList';
export { default as Breadcrumb } from './Breadcrumb';
export { default as Button } from './Button';
export { default as Card } from './Card';
export { default as CardGroup } from './CardGroup';
export { default as Carousel } from './Carousel';
export { default as Cascader } from './Cascader';
export { default as Checkbox } from './Checkbox';
export { default as DatePicker } from './DatePicker';
export { default as Datum } from './Datum';
export { default as Divider } from './Divider';
export { default as Drawer } from './Drawer';
export { default as Dropdown } from './Dropdown';
export { default as EditableArea } from './EditableArea';
export { default as Form } from './Form';
export { default as Gap } from './Gap';
export { default as Grid } from './Grid';
export { default as Icon } from './Icon';
export { default as Image } from './Image';
export { default as Input } from './Input';
export { default as Lazyload } from './Lazyload';
export { default as List } from './List';
export { default as Menu } from './Menu';
export { default as Message } from './Message';
export { default as Modal } from './Modal';
export { default as Pagination } from './Pagination';
export { default as Popover } from './Popover';
export { default as Progress } from './Progress';
export { default as Radio } from './Radio';
export { default as Rate } from './Rate';
export { default as Rule } from './Rule';
export { default as Scroll } from './Scroll';
export { default as Select } from './Select';
export { default as Slider } from './Slider';
export { default as Spin } from './Spin';
export { default as Sticky } from './Sticky';
export { default as Switch } from './Switch';
export { default as Table } from './Table';
export { default as Tabs } from './Tabs';
export { default as Tag } from './Tag';
export { default as Textarea } from './Textarea';
export { default as Tooltip } from './Tooltip';
export { default as Transfer } from './Transfer';
export { default as Tree } from './Tree';
export { default as TreeSelect } from './TreeSelect';
export { default as Upload } from './Upload';